import { CheckCircle2, CircleAlert, X } from 'lucide-react';
import { useEditorStore } from '../../store/editorStore';

export function ToastViewport() {
  const toasts = useEditorStore((state) => state.toasts);
  const dismiss = useEditorStore((state) => state.dismissToast);
  return <div className="toast-viewport">{toasts.map((toast) => (
    <div className={`toast toast-${toast.tone}`} key={toast.id}>
      {toast.tone === 'success' ? <CheckCircle2 size={15} /> : toast.tone === 'error' ? <CircleAlert size={15} /> : null}
      <span>{toast.message}</span><button onClick={() => dismiss(toast.id)}><X size={13} /></button>
    </div>
  ))}</div>;
}
